import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./views/Layout";
import Home from "./views/Home";
import Upload from "./views/Upload";
import DirectDownload from "./views/DirectDownload";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="upload" element={<Upload />} />
            <Route path="direct-download" element={<DirectDownload />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
